import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'noComma',
    standalone: false
})
export class NoCommaNumberPipe implements PipeTransform {
    transform(val: string | null): string {
        if (val !== undefined && val !== null) {
            return val.toString().replace(/,/g, '');
        } else {
            return '';
        }
    }
}
